import {UPDATE_INFO_FORM_IMG} from '../actions/types';

export default function(state={
	imgSrc:null
}, action) {
	switch(action.type) {
		case UPDATE_INFO_FORM_IMG:
			return {
				...state, 
				imgSrc: action.payload
			};
	}
	return state;
}